export const DEFAULT_LANGUAGE = 'ca_ES';
